const tourConfig1 = [
  {
    selector: "#root",
    content: "Welcome to Puzzled. Here is a quick walkthrough on how to solve the levels in Puzzled. The gameplay involves getting to the successive levels by whatever means necessary."
  },
  {
    selector: '[data-tut="reactour__source"]',
    content: "Click on View Source to find possible clues in the source code.",
    position: "bottom"
  },
  {
    selector: '[data-tut="reactour__level"]',
    content: "While the level image is the main element in each level, the image name could also be a relevant clue."
  },
  {
    selector: '',
    content: "Most level answers should be entered in the answer box right at the bottom of the screen. But in levels like this where answer box is hidden, you might need to click a particular section in the image in order to proceed."
  }
]

const tourConfig2 = [
  {
    selector: '[data-tut="reactour__hints"]',
    content: "There are timed hints which get unlocked as you play the level. They can be checked here by clicking on the heart icon.",
    position: "bottom"
  },
  {
    selector: '[data-tut="reactour__answer"]',
    content: "Most level answers should be entered in the answer box right at the bottom of the screen. But in certain levels where answer box is hidden, you might need to click a particular section on the image or change the last part of the URL in order to proceed.",
    position: "top"
  },
  {
    selector: '[data-tut="reactour__leader"]',
    content: "You can check the Leaderboard from this button which shows your rank and where you stand among the competition."
  },
  {
    selector: '[data-tut="reactour__disqus"]',
    content: "Whenever you feel you are stuck, or think you might need a nudge from the moderators in order to proceed, you can drop a message in our in-level disqus forum and our mods will help you out."
  },
  {
    selector: "#root",
    content: "That's pretty much it. You have completed Puzzled 101 and are now ready to crack the game. To know more, you could also read our Rules page. All the best, and Happy Puzzling!"
  }
]

export { tourConfig1, tourConfig2 };
